var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAreaStacked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9.3h-7.6a1.8 1.8 0 00-1 .3l-7.5 6-1-.2-9.6-2.1a1 1 0 00-.6.1.8.8 0 00-.3.7v16.5a1.5 1.5 0 001.6 1.6h26a1.5 1.5 0 001.6-1.6V2A1.5 1.5 0 0027.9.3z",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 8.2c-.3 0-.6 0-.8.2l-8.5 7-8.4 1.5-10-1.6a1 1 0 00-.7.2 1.2 1.2 0 00-.3.6v6.3a.8.8 0 00.7.8h27.7a.8.8 0 00.8-.8V9a.9.9 0 00-.5-.8z",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 18.8L1 17.2a1.2 1.2 0 01-1-1c0-.6.7-1 1.2-1L12 16.7l7.4-1.4 8.5-7a1 1 0 011.3 1.6l-8.8 7.3zM12.4 8.5L.9 6A1 1 0 010 4.7 1 1 0 011.3 4L12 6.3 19.6 0h9a1 1 0 011.1 1 1 1 0 01-1 1h-8.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaStacked);
export default __webpack_public_path__ + "static/media/area-stacked.eeb6b43b.svg";
export { ForwardRef as ReactComponent };